import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import HomePage from './components/HomePage/HomePage';
import About from './components/About/About';
import Site from './components/Site/Site';
import sitesData from './/sites.json'; // Import sites.json directly

const App = () => {
    return (
        <HelmetProvider>
            <Router>
                <ScrollToTop /> {/* This ensures the scroll resets on route change */}
                <Routes>
                    <Route path="/" element={<HomePage sites={sitesData} />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/:link" element={<Site />} />
                </Routes>
            </Router>
        </HelmetProvider>
    );
};

export default App;